import React from 'react'
import './loader.scss'

const Loader = (props) => {
    return (
        <div className='huntplanner-load-spinner' style={{ position: props.position ? props.position : '', left: props.left ? props.left : '' }}>
            <div className="loader-spinner" style={{ width: props.width ? props.width : '' }}></div>
        </div>
    )
}

export default Loader
